import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { LocationEmailIdentityComponent } from 'app/components/location-email-identity/LocationEmailIdentityComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useUser } from 'app/utils'

// Location email identity (TRK-6050). Gated on Manage Workspace (TRK-6130); supers
// always pass. observer: reads authStore.user, which resolves asynchronously.
const LocationEmail = observer(function LocationEmail() {
  const user = useUser()
  const checkPermission = useCheckPermission()

  if (!user) return <></>
  if (!checkPermission(`settings:workspace`)) {
    return <Navigate to="../general" replace />
  }

  return <LocationEmailIdentityComponent />
})

export default LocationEmail
